import CenteredLayout from "../features/layout/Centered"
import { useCMSReady } from "../domain/CMS/useCMSReady"
import appInsightsLogger from "../features/logging/appInsightsLogger"
import Spinner from "../features/shared/components/Spinner"
import ContactInfo from "../features/shared/components/ContactInfo"

export const ContactUs = () => {
  // Use useCMSReady for CMS loading state
  const {
    cms: cmsContent,
    isLoading,
    isReady,
    hasError,
  } = useCMSReady(["contactUs"])

  if (isLoading) {
    return <Spinner />
  } else if (hasError || !isReady) {
    const errorMessage = `ContactUs -- Error loading CMS content`
    appInsightsLogger.traceError(errorMessage)
    throw new Error(errorMessage)
  }

  const contactUsText = cmsContent.contactUs

  if (isLoading) {
    return (
      <CenteredLayout>
        <Spinner />
      </CenteredLayout>
    )
  } else if (hasError || !isReady) {
    const errorMessage = `FAQ -- Error loading CMS content`
    appInsightsLogger.traceError(errorMessage)
    throw new Error(errorMessage)
  }
  return (
    <CenteredLayout>
      <div className="w-1/5">
        <ContactInfo text={contactUsText!} />
      </div>
    </CenteredLayout>
  )
}

export default ContactUs
